import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ControlTypes } from '@nx-customer-apps/shared/enums';
import { MultiQuestionbox, TypesHTMLHelper } from '@nx-customer-apps/shared/utils';
import { NgClass } from '@angular/common';
import { TextboxComponent } from '../textbox/textbox.component';
import { RadioComponent } from '../radio/radio.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { CheckboxComponent } from '../checkbox/checkbox.component';
import { SliderComponent } from '../slider/slider.component';
import { AsPipe } from '../../pipes';

@Component({
    selector: 'vp-multi-questionbox',
    templateUrl: './multi-questionbox.component.html',
    styleUrl: './multi-questionbox.component.scss',
    imports: [NgClass, TextboxComponent, RadioComponent, DropdownComponent, CheckboxComponent, SliderComponent, ReactiveFormsModule, AsPipe]
})
export class MultiQuestionboxComponent {
    @Input() form: FormGroup;
    @Input() question: MultiQuestionbox;
    readonly CONTROL_TYPES: typeof ControlTypes = ControlTypes;
    readonly TYPES = TypesHTMLHelper;
}
